import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const header = styled('div')`
  text-align: center;

  span {
    color: var(--black);
    display: block;
    font-size: var(--ph-heading-one);
    font-family: var(--ph-font-family-franklin-book-regular);
  }
`;

const logo = styled(Svg)`
  width: 130px;
`;

export default { Header: header, Logo: logo };
